export const getDuplicateIndexesOfArray = (arr) => {
	return arr.reduce((prev, cur, index, array) => {
		let itemIndex = array.indexOf(cur);
		if (itemIndex !== index && cur) {
			prev.indexOf(index) === -1 && prev.push(index);
			prev.indexOf(itemIndex) === -1 && prev.push(itemIndex);
		}
		return prev;
	}, []);
};

export const onRemoveDuplicates = (array) => {
	let uniques = [];
	array.forEach((element) => {
		let duplicated = uniques.find(
			(item) => item.id === element.id || item === element
		);
		!duplicated && uniques.push(element);
	});
	return uniques;
};
